import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Nomes de atributos que carregam um instante UTC apesar de o nome NÃO terminar
 * em "Utc" — as exceções da regra do `DateInterceptor`.
 *
 * A convenção do backend é o sufixo: `OccurredOnUtc`, `ScheduledStartOnUtc`. Os
 * campos que fogem dela (`SendAt`, `SubscribedOn`, ...) passavam despercebidos
 * e obrigavam cada serviço a converter o valor à mão depois da resposta.
 * Declarados aqui, entram no mesmo caminho de todos os outros: o interceptor
 * converte-os no corpo (nos dois sentidos) e nos parâmetros de query, e o
 * serviço deixa de ter conversão nenhuma.
 *
 * Declarar um campo é afirmar que os DÍGITOS são UTC — não que o valor traz um
 * `Z`. O `Z` não prova nada: a convenção desta app é hora de parede com o
 * sufixo decorativo, e a maioria dos campos chega assim. Declarar por engano um
 * campo de parede tira-lhe o offset e o valor aparece deslocado, sem erro
 * nenhum. Foi o que aconteceu com `EntryedOn` de `/OData/Accesses`, que chega
 * `18:21Z` com o servidor a responder às `21:27Z` — parede, não instante.
 * Confirme na resposta crua antes de declarar.
 *
 * A comparação é insensível a maiúsculas/minúsculas, portanto `'SendAt'` cobre
 * também o `sendAt` que chega em camelCase pelo hub.
 *
 * @see withUtcDateFields
 */
export const UTC_DATE_FIELDS = new HttpContextToken<readonly string[]>(() => []);

/**
 * Açúcar para declarar as exceções num pedido:
 *
 * ```ts
 * this.http.get<Chat[]>(url, {
 *   context: withUtcDateFields(['SendAt']),
 *   withCredentials: true,
 * });
 * ```
 *
 * O segundo argumento existe para acumular com outros tokens já em uso no mesmo
 * pedido (`SKIP_PENDING_MUTATION_GUARD`, por exemplo), em vez de os substituir.
 */
export function withUtcDateFields(
  fields: readonly string[],
  context: HttpContext = new HttpContext(),
): HttpContext {
  return context.set(UTC_DATE_FIELDS, fields);
}
